angular.module('impactx.ruleset').controller('AddImportantMenuItemDialogCtrl', [
    '$mdDialog',
    '$scope',
    'themeFactory',
    'TranslationService',
    'workspace',
    'addImportantMenuItemsLabel',
    'chooseIconLabel',
    'selectedItem',
    AddImportantMenuItemDialogCtrl]);

function AddImportantMenuItemDialogCtrl($mdDialog, $scope, themeFactory, TranslationService, workspace,
                                        addImportantMenuItemsLabel, chooseIconLabel, selectedItem) {
    var self = this;
    var itemAlreadyExisting = !!selectedItem;
    $scope.abortLabel = TranslationService.get("abort");
    $scope.addImportantMenuItemsLabel = addImportantMenuItemsLabel;
    $scope.chooseIconLabel = chooseIconLabel;
    $scope.theme = themeFactory.getTheme();
    $scope.workSpaceCopy = JSON.parse(JSON.stringify(workspace));

    $scope.availableMenuItems = [];

    this.checkIfNotAlreadyAssignedAndAdd = function (item, workspace) {
        for (var i = 0; i < workspace.importantMenuItems.length; i++) {
            if (workspace.importantMenuItems[i].view.toUpperCase() === item.view.toUpperCase()) {
                return;
            }
        }
        $scope.availableMenuItems.push(item);
    };

    this.collectAvailableMenuItems = function(workspace) {
        for (var i = 0; i < workspace.menuitems.length; i++) {
            var menuItem = workspace.menuitems[i];
            if (!menuItem.subitems) {
                self.checkIfNotAlreadyAssignedAndAdd(menuItem, workspace);
            }
            else {
                for (var j = 0; j < menuItem.subitems.length; j++) {
                    self.checkIfNotAlreadyAssignedAndAdd(menuItem.subitems[j], workspace);
                }
            }
        }
    };
    self.collectAvailableMenuItems($scope.workSpaceCopy);

    $scope.selectedItem = {};
    $scope.wizardIndex = 0;

    if (selectedItem) {
        $scope.selectedItem = selectedItem;
        $scope.wizardIndex = 1;
    }

    this.cancel = function () {
        $mdDialog.cancel();
    };

    this.selectItem = function (item) {
        $scope.selectedItem = item;
        $scope.wizardIndex = 1;
    };

    this.chooseIcon = function (icon) {
        $scope.selectedItem.icon = icon;
        $mdDialog.hide(itemAlreadyExisting ? null : $scope.selectedItem);
    }
}